import { render, staticRenderFns } from "./Websites.vue?vue&type=template&id=985910be&scoped=true&"
import script from "./Websites.vue?vue&type=script&lang=ts&"
export * from "./Websites.vue?vue&type=script&lang=ts&"
import style0 from "./Websites.vue?vue&type=style&index=0&id=985910be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985910be",
  null
  
)

export default component.exports